import React from "react";
import { Paperclip, Sparkles } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { caseScenarioById } from "../lib/caseScenarios";

/**
 * Explains the selected analysis, or asks for a file and offers a plain case.
 */
export default function CaseScenarioHint({
  scenarioId = null,
  hasAttachments = false,
  onAttach,
  onClear,
}) {
  const { t } = useLanguage();
  const scenario = caseScenarioById(scenarioId);
  if (!scenario) return null;

  if (!hasAttachments) {
    return (
      <div className="mt-3 space-y-1" data-testid="scenario-hint">
        <button
          type="button"
          data-testid="scenario-attach-prompt"
          className="flex items-center gap-1.5 text-left text-sm text-muted-foreground"
          onClick={onAttach}
        >
          <Paperclip className="h-3.5 w-3.5 flex-shrink-0 text-medical" aria-hidden="true" />
          <span>{t(scenario.attachKey)}</span>
        </button>
        <button
          type="button"
          data-testid="scenario-ask-without-file"
          className="text-sm text-muted-foreground underline"
          onClick={onClear}
        >
          {t("scenario.askWithoutFile")}
        </button>
      </div>
    );
  }

  return (
    <p
      className="mt-3 flex items-start gap-1.5 text-sm text-muted-foreground"
      data-testid="scenario-description"
    >
      <Sparkles className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-medical" aria-hidden="true" />
      <span>{t(scenario.descriptionKey)}</span>
    </p>
  );
}
